// extracted by mini-css-extract-plugin
export var banner = "cookie-banner-module--banner--f8f24";
export var btnAccept = "cookie-banner-module--btnAccept--89777";
export var btnReject = "cookie-banner-module--btnReject--70457";
export var buttons = "cookie-banner-module--buttons--3b6f4";
export var inner = "cookie-banner-module--inner--5656a";
export var slideUp = "cookie-banner-module--slideUp--d76c8";
export var text = "cookie-banner-module--text--0872b";